/** @jsxImportSource @emotion/react */
import { MutateShopPaymentProviderTemplate } from "./MutateShopPaymentProviderTemplate";

export const AddNewShopPaymentProvider = () => {
  return <MutateShopPaymentProviderTemplate />;
};
